import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export function Popup({
    content,
    anchor = 'relative',
    className = '',
    contentClassName = '',
    children,
}: React.PropsWithChildren<{ className?: string; content: React.ReactNode; contentClassName?: string; anchor?: 'relative' | 'body' }>) {
    const { ref, isVisible } = useIsVisible<HTMLDivElement>();

    const [bodyContent, setBodyContent] = useState<HTMLDivElement | null>(null);

    const showContent = anchor === 'relative' ? isVisible : Boolean(bodyContent) || isVisible;

    return (
        <div className={`relative ${className}`}>
            <div className='peer'>{children}</div>
            <div
                ref={ref}
                className={`
                    absolute hidden peer-hover:inline-flex hover:inline-flex z-999 w-fit h-fit
                    transition-all duration-300
                    ${showContent ? 'opacity-100' : 'opacity-0 pointer-events-none'}
                    ${contentClassName}
                `}
            >
                {anchor === 'relative' && showContent && content}
                {anchor === 'body' &&
                    showContent &&
                    createPortal(
                        <div
                            ref={setBodyContent}
                            onMouseLeave={() => {
                                setBodyContent(null);
                            }}
                        >
                            {content}
                        </div>,
                        document.body, // render relative to body, not parent
                    )}
            </div>
        </div>
    );
}

function useIsVisible<T extends HTMLElement>() {
    const ref = useRef<T | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                threshold: 0.1, // adjust how much of element should be visible
            },
        );

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return { ref, isVisible };
}

// function useElementLoaded(element: HTMLElement | null) {
//     const [loaded, setLoaded] = useState(false);

//     useEffect(() => {
//         // const element = elRef.current;
//         if (!element) return;

//         // If already has children, mark as loaded
//         if (element.children.length > 0) {
//             setLoaded(true);
//             return;
//         }

//         const observer = new MutationObserver(() => {
//             if (element.children.length > 0) {
//                 setLoaded(true);
//                 observer.disconnect(); // stop observing after loaded
//             }
//         });

//         observer.observe(element, { childList: true, subtree: true });

//         return () => observer.disconnect();
//     }, [element]);

//     return loaded;
// }
